
//localStorage.setItem('apiURL', 'https://tomcat.sedetc.gob.pe/cas-services-0.0.3')
//localStorage.setItem('apiURL', 'https://tomcat.sedetc.gob.pe/cas-services-0.0.2')
//localStorage.setItem('apiLOGIN', 'https://tomcat.sedetc.gob.pe/cas-services-0.0.1')
//localStorage.setItem('apiAUTH', 'https://tcperu.auth0.com/api/v2')
//localStorage.setItem('apiTOKEN', 'https://tcperu.auth0.com/oauth/token')

//exportando la API
export const apiURL= 'https://tomcat.sedetc.gob.pe/cas-services-0.0.2'; 
//export const apiURL= 'http://localhost:8091'; 
export const apiLOGIN= 'https://tomcat.sedetc.gob.pe/cas-services-0.0.1'; 
export const apiAUTH= 'https://tcperu.auth0.com/api/v2'; 
export const apiTOKEN= 'https://tcperu.auth0.com/oauth/token'; 
//export const apiAUTH2= 'https://login.auth0.com/api/v2'; 


export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: localStorage.getItem('AccessToken') || null,
  tokenExpiration: localStorage.getItem('tokenExpiration') || null,
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  },
  userMail: '',

  // Dni y nombres obtenidos de la 2da Api del Login
  dni: null,
  nombres: null,  
  
  //userRol: JSON.parse(localStorage.getItem('userRolData')) || [], // Datos de la API de roles 
  userRol: [], // Datos de la API de roles 
  desApp: '', //del item.descripcion en aplicaciones
  desArea: '' // del item.descripcion en areas

};



// WEBPACK FOOTER //
// ./src/store/state.js